import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CircularProgress } from "@mui/material";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { format, parse } from "date-fns";
import {
  FaUserCheck,
  FaWarehouse,
  FaTruckArrowRight,
  FaBoxOpen,
  FaTruckFast,
  FaCircleCheck,
  FaCircleXmark,
  FaClipboardCheck,
} from "react-icons/fa6";

const STATUS_ICON_MAP = {
  // 🔹 Internal / Generic
  "Order accepted by lmbp": FaUserCheck,
  "Order delivered to hub": FaWarehouse,
  "Order send for Delivery": FaTruckArrowRight,

  "Ready for Pickup": FaBoxOpen,
  "In Transit": FaTruckFast,
  "Manifested": FaClipboardCheck,
  "Out for Delivery": FaTruckFast,

  // 🔸 Trackon specific
  "S/MENT BOOKED": FaUserCheck,
  "S/MENT ARRIVED": FaBoxOpen,

  "PROCESSING BAG FOR DELHI AIRPORT HUB": FaTruckArrowRight,
  "PROCESSING BAG FOR AMRITSAR BRANCH": FaTruckArrowRight,

  "ARRIVED AT DESTINATION": FaWarehouse,

  "DELIVERY MANIFEST PREPARED FOR MAJITHA ROAD 3": FaClipboardCheck,

  "OUT FOR DELIVERY": FaTruckFast,

  "DELIVERED WITH MOBILE APP UPDATE, RECEIVED BY SELF - NULL": FaCircleCheck,

  // 🔻 Exceptions
  "Delivery Attempted (NDR)": FaTruckArrowRight,

  Delivered: FaCircleCheck,
  Cancelled: FaCircleXmark,
  CANCELLED: FaCircleXmark,
};

const OrderTrackingModal = ({ show, handleClose, columnData }) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [pageSize] = useState(10);
  const [summary, setSummary] = useState(null);
  // const [delhiveryGroups, setDelhiveryGroups] = useState({});
  const [openGroup, setOpenGroup] = useState(null);  

  const handleBack = () => {
    handleClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (show) {
      fetchShipmentTrackingData(1);
    }
  }, [show]);

  const getStatusIcon = (status) => {
    const Icon = STATUS_ICON_MAP[status];
    return Icon ? <Icon size={14} /> : <FaTruckFast size={14} />;
  };

//   const normalizeDate = (item) => {
//   if (!item?.DateandTime) return null;

//   // Convert "YYYY-MM-DD HH:mm:ss" → ISO
//   const iso = item.DateandTime.replace(" ", "T");

//   const d = new Date(iso);
//   return isNaN(d.getTime()) ? null : d;
// };

 const normalizeDate = (item) => {
   if (!item?.DateandTime) return null;
 
   try {
     const parsed = parse(
       item.DateandTime,
       "dd-MM-yyyy HH:mm:ss",
       new Date()
     );
     return parsed;
   } catch {
     return null;
   }
 };

  //  const fetchShipmentTrackingData = async (page) => {
  //   setLoading(true);
  //   try {
  //     const payload = {
  //       username: loggedInUserName,
  //       ewaybillNumber: columnData?.ourWaybillNumber,
  //     };

  //     const api = 
  //       columnData?.orderSubmitSource === "DIRECT_DELHIVERY"
  //         ? apiList.SHIPMENT_TRACKING_DELHIVERY
  //         : columnData?.orderSubmitSource === "TRACKON" 
  //         ? apiList.SHIPMENT_TRACKING_TRACKON 
  //         : apiList.SHIPMENT_TRACKING;

  //     const response = await axiosPostApi(
  //       `${api}?pageSize=${pageSize}&pageNo=${page}`,
  //       payload
  //     );

  //     if (
  //       response?.data?.status === true &&
  //       response?.data?.respCode === "00"
  //     ) {
  //       const data = response?.data?.data;

  //       const trackingHistoryList = data?.tracking?.history || [];

  //       let trackingDataList = [];

  //       if (columnData?.orderSubmitSource === "TRACKON") {
  //         trackingDataList = normalizeTrackonTracking(
  //         data?.trackonTracking
  //         );
  //       } else {
  //         trackingDataList = data?.trackingdata || [];
  //       }
        
  //       // ✅ Always show trackingHistory first, then trackingdata
  //       let trackingList = [
  //         ...trackingHistoryList,
  //         ...trackingDataList,
  //       ];

  //       trackingList = trackingList
  //       .map(item => ({
  //         ...item,
  //         parsedDate: normalizeDate(item),
  //       }))
  //       .sort((a, b) => {
  //         if (!a.parsedDate) return 1;
  //         if (!b.parsedDate) return -1;
  //         return b.parsedDate.getTime() - a.parsedDate.getTime();
  //       });

  //       // if (data?.summary?.Status === "Book") {
  //       //   trackingList = [
  //       //     ...trackingList,
  //       //     {
  //       //       Status: data?.response || "Shipment yet to be picked up.",
  //       //       DateandTime: data?.summary?.orderedon,
  //       //     },
  //       //   ];
  //       // }''

  //       if (data?.summary?.Status === "Book") {
  //         const bookItem = {
  //           Status: data?.response || "Shipment yet to be picked up.",
  //           DateandTime: data?.summary?.orderedon,
  //         };
        
  //         trackingList = [
  //           ...trackingList,
  //           {
  //             ...bookItem,
  //             parsedDate: normalizeDate(bookItem),
  //           },
  //         ];
  //       }


  //       if (columnData?.orderSubmitSource === "DIRECT_DELHIVERY") {
  //         const shipment =
  //           data?.delhiveryTracking?.ShipmentData?.[0]?.Shipment;
        
  //         if (shipment) {
  //           const grouped = groupDelhiveryScans(shipment);
  //           setDelhiveryGroups(grouped);
  //         }
  //       }

  //       const modifiedList = modifyStructure(trackingList);
  //       if(columnData?.orderSubmitSource === "DIRECT_DELHIVERY"){
  //         setOrderData(trackingList);
  //       }else{
  //         // const groupedStatus = groupByStatus(modifiedList);
  //         const groupedStatus = groupByStatusOrdered(trackingList);
  //         setOrderData(groupedStatus);
  //       }

  //       setSummary(data?.summary || null);
  //       if (columnData?.orderSubmitSource === "TRACKON") {
  //         setSummary(data?.trackonTracking?.CustomersummaryTrack || null);
  //       } else {
  //         setSummary(data?.summary || null);
  //       }

  //     } else {
  //       CustomAlert({
  //         title: "Failed",
  //         text: response?.data?.message || "Failed to fetch data",
  //         icon: "error",
  //         confirmButtonText: "Retry",
  //       });
  //     }
  //   } catch (error) {
  //     setOrderData([]);
  //     CustomAlert({
  //       title: "Error",
  //       text: "An error occurred while fetching the data. Please try again later.",
  //       icon: "error",
  //       confirmButtonText: "Retry",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

     const fetchShipmentTrackingData = async (page) => {
    setLoading(true);
    try {
      const payload = {
        username: loggedInUserName,
        orderId: columnData?.id
      };

      const api = apiList.ALL_CARRIER_ORDER_TRACKING;

      const response = await axiosPostApi(
        `${api}?pageSize=${pageSize}&pageNo=${page}`,
        payload
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        const data = response?.data?.data;

        const history = data?.tracking?.history || [];

        let trackingList = normalizeUnifiedTracking(history);

        trackingList = trackingList
        .map(item => ({
          ...item,
          parsedDate: normalizeDate(item),
        }))
        .sort((a, b) => {
          if (!a.parsedDate) return 1;
          if (!b.parsedDate) return -1;
          return b.parsedDate.getTime() - a.parsedDate.getTime();
        });

        if (data?.summary?.Status === "Book") {
          const bookItem = {
            Status: data?.response || "Shipment yet to be picked up.",
            DateandTime: data?.summary?.orderedon,
          };
        
          trackingList = [
            ...trackingList,
            {
              ...bookItem,
              parsedDate: normalizeDate(bookItem),
            },
          ];
        }

        const groupedStatus = groupByStatusOrdered(trackingList);
        setOrderData(groupedStatus);

        setSummary(data?.tracking || null);

      } else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed to fetch data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setOrderData([]);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

// const normalizeTrackonTracking = (trackonTracking) => {
//   if (!trackonTracking?.lstDetails) return [];

//   return trackonTracking.lstDetails.map(item => {
//     const dateTimeStr = `${item.EVENTDATE.split("/").reverse().join("-")} ${item.EVENTTIME}`;

//     return {
//       Status: item.CURRENT_STATUS?.trim(),
//       Location: item.CURRENT_CITY,
//       DateandTime: dateTimeStr,
//       parsedDate: new Date(dateTimeStr),
//       trackingCode: item.TRACKING_CODE,
//     };
//   });
// };

const normalizeUnifiedTracking = (history = []) => {
  return history.map(item => ({
    Status: item.status,
    Location: item.location,
    DateandTime: item.dateTime,
    parsedDate: normalizeDate({ DateandTime: item.dateTime }),
  }));
};

  const groupDelhiveryScans = (shipment) => {
  if (!shipment?.Scans) return {};

  return shipment.Scans.reduce((acc, item) => {
    const detail = item.ScanDetail;
    if (!detail) return acc;

    const key = detail.Scan || "Other";

    if (!acc[key]) acc[key] = [];
    acc[key].push(detail);

    return acc;
  }, {});
};

  const groupByStatus = (list = []) => {
    return list.reduce((acc, item) => {
      const key = item.Status || item.status || "Other";
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
  };

  const groupByStatusOrdered = (list = []) => {
  const map = new Map();

  list.forEach(item => {
    const key = item.Status || "Other";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(item);
  });

  return Array.from(map.entries()); // preserves order
};

// const isDeliveredDelivery =
//   // Delhivery case (groups object)
//   Object.keys(delhiveryGroups || {}).includes("Delivered") ||

//   // Internal / Trackon case (orderData is object)
//   (orderData &&
//     !Array.isArray(orderData) &&
//     Object.keys(orderData).some((status) =>
//       status.toLowerCase().includes("delivered")
//     )) ||

//   // Direct delhivery internal array case
//   (Array.isArray(orderData) &&
//     orderData.some((item) =>
//       String(item?.Status).toLowerCase().includes("delivered")
//     ));

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "600px",
                borderRadius: "24px",
                padding: "24px",
                paddingRight:"16px",
                paddingLeft:"16px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
                position: "relative",
              }}
            >
              {/* Background Images */}
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="rightImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />

              {/* Header */}
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                  paddingTop: "0px",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <LocalShippingOutlinedIcon
                      style={{ color: "#ff7a00", fontSize: "28px" }}
                    />
                    <h5 className="modal-title main-title font-medium">
                      Order Tracking Details
                    </h5>
                  </div>
                </div>

                <HighlightOffIcon
                  onClick={handleBack}
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
              </div>

              {/* Body */}
              <form onSubmit={handleSubmit}>
                <div
                  className="scoped-modal modal-body custom-scrollbar"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                    maxHeight: "400px",
                    overflowY: "auto",
                    paddingRight: "8px",
                  }}
                >
                  {loading ? (
                    <CircularProgress />
                  ) : orderData ? ((
                      <div className="w-full px-6 py-4 pb-0 relative">
                      <div className="flex flex-col items-start justify-center relative">
                        {orderData.map(([status, items], index) => {
                          const isGrouped = items.length > 1;
                          const isCancelled = status === "Cancelled" || status === "CANCELLED";
                          const isDelivered = status === "Delivered" || status === "DELIVERED WITH MOBILE APP UPDATE, RECEIVED BY SELF - NULL";                          
                        
                          return (
                          <div key={status} className="flex items-start w-full relative mb-6">

                            {/* Line */}
                            {index < Object.keys(orderData).length - 1 && (
                              <div
                                className="absolute left-[16px] top-6 w-[3px] bg-orange-500"
                                style={{ height: "calc(100% + 24px)" }}
                              />
                            )}

                            {/* Dot */}
                            <div className="flex flex-col items-center mr-4 relative z-10">
                              {/* <div
                                className={`w-6 h-6 rounded-full border-4 ${
                                  index === Object.entries(orderData).length - 1
                                    ? `${status === "Cancelled" || status === "CANCELLED" ? 'border-red-500 bg-red-500' : status === "Delivered" ? "border-green-500 bg-green-500" : "border-orange-500 bg-white"}`
                                    : "border-orange-500 bg-orange-500"
                                } flex items-center justify-center`}
                              ></div> */}
                              <div
                                className={`w-9 h-9 rounded-full border-4 ${
                                  Object.keys(orderData).length > 1
                                    ? `${isCancelled
                                        ? "border-[#eaebf1] bg-red-500"
                                        : isDelivered
                                        ? "border-[#eaebf1] bg-green-500"
                                        : "border-[#eaebf1] bg-orange-500"}`
                                    : "border-[#eaebf1] bg-orange-500"
                                } flex items-center justify-center text-white`}
                                  style={{
                                    boxShadow: "0 0 10px rgba(249,115,22,0.8)",
                                  }}
                              >
                                {getStatusIcon(status)}
                              </div>

                            </div>

                            {/* Card */}
                            <div className="bg-[#fff6ef] border border-orange-200 rounded-xl px-4 py-2 w-full shadow-sm">

                            {/* Header */}
                            <div
                              className={`flex justify-between items-center ${
                              isGrouped ? "cursor-pointer" : ""
                            }`}
                              onClick={() =>
                                isGrouped &&
                                 setOpenGroup(openGroup === status ? null : status)
                              }
                            >
                              <div className="flex gap-2">
                              <span className="text-sm font-semibold text-gray-800">
                                {status}
                              </span>
                              {isGrouped && 
                                <span className="text-gray-500 text-xs bg-orange-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                                    {items.length} update
                                    {items.length !== 1 ? "s" : ""}
                                </span>
                              }
                              </div>
                    
                              {isGrouped ? (
                                <span className="text-orange-500 text-lg">
                                  {openGroup === status ? "-" : "+"}
                                </span>
                              ) : (
                                <div>
                                {items[0].parsedDate && (
                                 <div className="text-xs text-gray-500 text-right whitespace-nowrap ml-2">
                                   {format(items[0].parsedDate, "dd-MM-yyyy hh:mm a")}
                                 </div>
                                )}
                               </div>
                               )}
                            </div>

                           {/* Single item (no dropdown) */}
                           {!isGrouped && (
                             <div className="mt-1 text-sm text-gray-600">
                               {items[0].Remark}
                               {items[0].Location && (
                                 <div className="text-xs text-gray-500">
                                   📍 {items[0].Location}
                                 </div>
                               )}
                               {/* {items[0].parsedDate && (
                                 <div className="text-xs text-gray-500 text-right">
                                   {format(items[0].parsedDate, "dd-MM-yyyy hh:mm a")}
                                 </div>
                               )} */}
                             </div>
                           )}

                          {/* Dropdown */}
                           {isGrouped && openGroup === status && (
                             <div className="mt-2 space-y-2">
                               {items.map((item, idx) => (
                                 <div
                                   key={idx}
                                   className="bg-white border border-orange-100 rounded-lg p-3 text-sm"
                                 >
                                   <div className="flex justify-between">
                                     <span>{item.Remark || "No additional details"}</span>
                                     {item.parsedDate && (
                                       <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                                         {format(item.parsedDate, "dd-MM-yyyy hh:mm a")}
                                       </span>
                                     )}
                                     </div>
                   
                                   {item.Location && (
                                     <div className="text-xs text-gray-500 mt-1">
                                       📍 {item.Location}
                                     </div>
                                   )}
                                 </div>

                               ))}
                             </div>
                           )}
                        </div>
                      </div>
                          );
                        })}

                      </div>
                    </div>
                    ) 
                  //   : (
                  //   <div className="w-full px-6 py-4 relative">
                  //     {/* Line */}
                  //      {/* <div
                  //         className={`absolute left-[40px] top-[32px] w-[3px] bg-orange-400 ${isDeliveredDelivery ? "bottom-[13px]" : "bottom-[30px]"}`}
                  //       /> */}
                  //       {/* <div className="absolute left-[40px] top-[32px] h-[58%] bottom-0 w-[3px] bg-orange-400" /> */}
                  //       {/* Vertical line */}
                  // <div
                  //   className="absolute left-[40px] top-[52px] bottom-[32px] w-[3px] bg-orange-400"
                  // />

                  //   <div className="flex flex-col space-y-4 ">
                  //     {/* 2️⃣ Delhivery Tracking */}
                  //       {Object.entries(delhiveryGroups).map(([scan, items], index) => {
                  //         const totalSteps = Object.keys(delhiveryGroups).length;
                  //         const isLast = index === totalSteps - 1;
                  //         const isCancelled = scan === "Cancelled" || scan === "CANCELLED";
                  //         const isDelivered = scan === "Delivered";                          

                  //         return (
                  //           <div key={scan} className="flex gap-3 items-start">
                  //             {/* Dot */}
                  //             <div
                  //                 className={`w-9 h-9 z-10 rounded-full border-4 ${
                  //                   isLast
                  //                     ? `${isCancelled
                  //                         ? "border-[#eaebf1] bg-red-500"
                  //                         : isDelivered
                  //                         ? "border-[#eaebf1] bg-green-500"
                  //                         : "border-[#eaebf1] bg-orange-500"}`
                  //                     : "border-[#eaebf1] bg-orange-500"
                  //                 } flex items-center justify-center text-white`}
                  //                 style={{
                  //                     boxShadow: "0 0 10px rgba(249,115,22,0.8)",
                  //                   }}
                  //               >
                  //                 {getStatusIcon(scan)}
                  //               </div>
                      
                  //             {/* Group Card */}
                  //             <div className="flex-1 border border-orange-200 rounded-xl bg-[#fff6ef] shadow-sm">
                  //               <div
                  //                 className="flex justify-between items-center px-4 py-2 cursor-pointer"
                  //                 onClick={() =>
                  //                   setOpenGroup(openGroup === scan ? null : scan)
                  //                 }
                  //               >
                  //                 <div className="flex gap-2">
                  //                  <span className="text-sm font-semibold text-gray-800">
                  //                    {scan}
                  //                  </span>
                  //                      <span className="text-gray-500 text-xs bg-orange-100 px-2 py-0.5  rounded-full whitespace-nowrap">
                  //                          {items.length} update
                  //                          {items.length !== 1 ? "s" : ""}
                  //                      </span>
                  //                 </div>
                  //                  <span className="text-orange-500 text-lg">
                  //                    {openGroup === scan ? "-" : "+"}
                  //                  </span>
                  //               </div>
                      
                  //               {openGroup === scan && (
                  //                 <div className="px-4 pb-3 space-y-2">
                  //                   {items.map((item, idx) => (
                  //                     <div
                  //                       key={`${scan}-${idx}`}
                  //                       className="bg-white rounded-lg p-3 text-sm border border-orange-100"
                  //                     >
                  //                       <div className="flex justify-between">
                  //                         <span className="text-gray-700">
                  //                           {item.Instructions}
                  //                         </span>
                  //                         <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                  //                           {format(
                  //                             new Date(item.ScanDateTime),
                  //                             "dd-MM-yyyy hh:mm a"
                  //                           )}
                  //                         </span>
                  //                       </div>
                      
                  //                       {item.ScannedLocation && (
                  //                         <div className="text-xs text-gray-500 mt-1">
                  //                           📍 {item.ScannedLocation}
                  //                         </div>
                  //                       )}
                  //                     </div>
                  //                   ))}
                  //                 </div>
                  //               )}
                  //             </div>
                  //           </div>
                  //         )
                  //       }
                  //       )}
                                          
                  //       {/* 1️⃣ Company Tracking History */}
                  //       {orderData.map((item, idx) => (
                  //         <div key={`internal-${idx}`} className="flex gap-3 items-center">

                  //           {/* Dot */}
                  //             <div
                  //               className={`w-9 h-9 z-10 rounded-full border-4 ${item?.Status === "Cancelled" || item?.Status === "CANCELLED" ? "border-[#eaebf1] bg-red-500" : "border-[#eaebf1] bg-orange-500"} flex items-center justify-center text-white`}
                  //               style={{
                  //                   boxShadow: "0 0 10px rgba(249,115,22,0.8)",
                  //                 }}
                  //             >
                  //               {getStatusIcon(item?.Status)}
                  //             </div>
                    
                  //           {/* Card */}
                  //           <div className="flex-1 bg-[#fff6ef] border border-gray-20 rounded-lg px-4 py-2 text-sm shadow-sm">
                  //                <div className="flex justify-between items-center">
                  //                  <span className="text-gray-800 font-semibold">
                  //                    {item.Status}
                  //                  </span>
                    
                  //                  {item.parsedDate && (
                  //                    <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                  //                      {format(item.parsedDate, "dd-MM-yyyy hh:mm a")}
                  //                    </span>
                  //                  )}
                  //                </div>
                  //           </div>
                  //         </div>
                  //       ))}
                        
                  //     </div>
                  //   </div>
                  //   )
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      No details available.
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-[8px]"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderTrackingModal;